// extracted by mini-css-extract-plugin
export default {"content":"word-sets-page_content__dksXe","searchBar":"word-sets-page_searchBar__wWUrC","list":"word-sets-page_list__wY5e8","element":"word-sets-page_element__MqOJB"};